<template>
  <div class='enter-show leading-tight'>
    <template v-if="currentUser">
      <div v-if="allowMoreRegistrations">
        <div class="mt-4 lg:bg-white lg:border lg:rounded lg:py-8 lg:px-4" v-if="!entryGroup.entry_group_id">
          <div class="w-full  overflow-hidden">
            <SeriesMembershipList />
            <p class="text-2xl md:text-center mb-6 font-medium">Please review your account information below before entering.</p>
            <div v-if="event.event_details.signup_text" class="text-sm py-2 whitespace-pre-wrap">{{event.event_details.signup_text}}</div>
            <div class="flex-row md:flex justify-center items-center">
              <div class='flex-1 mr-1'>
                <ul class="font-light mt-4 leading-normal" v-if="currentUser.address">
                  <li><span class="font-bold">Farm:</span> {{currentUser.farm_name}}</li>
                  <li><span class="font-bold">Owner:</span> {{currentUser.first_name}} {{currentUser.last_name}}</li>
                  <li><span class="font-bold">Address:</span> {{currentUser.address.address_line1}}<br>{{currentUser.address.city}}, {{currentUser.address.state}} {{currentUser.address.zip}}</li>
                  <li><span class="font-bold">Phone:</span> {{currentUser.phone_number}}</li>
                  <li><span class="font-bold">Email:</span> {{currentUser.email}}</li>
                </ul>
                <p class="mt-4">
                  See something that isn't correct?
                  <br>
                  <router-link class="link text-sm" :to="{name:'my-profile'}">Click Here to edit</router-link>
                </p>
              </div>
              <div class="flex-1 mt-2 md:mt-0">
                <template v-if="!entryLoading">
                  <div class="border-t-2 border-gray-600 h-1 md:invisible my-3 md:m-0 md:h-0"></div>
                  <label class="md:w-full block text-gray-700 font-bold mb-6" v-if="event.entry_settings.has_member_pricing">
                    <p class="text-xl font-light">Are you a {{event.entry_settings.member_pricing_label}}?</p>
                    <input v-model="entryGroup.member_pricing" class="mr-2 leading-tight" type="checkbox">
                    <span class="text-sm">
                      I am a {{event.entry_settings.member_pricing_label}}
                    </span>
                  </label>
                  <label class="md:w-full block text-gray-700 font-bold mb-1">
                    <p class="text-xl font-light mb-1">Please read and agree to the following:</p>
                    <input v-model="agreeToRules" class="mr-2 leading-tight" type="checkbox">
                    <span class="text-sm">
                      <template v-if="event.event_details.enter_show_text">
                        {{event.event_details.enter_show_text}}
                      </template>
                      <template v-else>
                        I have read and agree to follow all show rules and waivers listed below and also all rules listed on the {{event.name}} Showman Page. I am either the exhibitor or the parent/guardian.
                      </template>
                    </span>
                  </label>
                  <template v-if="event.files.constructor === Array">
                    <div v-for="(f, i) in event.files" :key="i">
                      <a v-if="f.required_agreement" :href="f.url" class="link" target="_blank">View {{f.label}}</a>

                    </div>
                  </template>
                  <template v-else>
                    <a v-if="event.files.Show_Rules" class="link" target="_blank" :href="event.files.Show_Rules">View {{this.event.status === 'EVENT' ? 'Event' :'Show'}} Rules</a>
                    <div v-for="(value, name) in event.files" :key="name">
                      <a v-if="name.includes('Rules') && name !== 'Show_Rules'" class="link" target="_blank" :href="value">View {{name}}</a>
                      <a v-if="name.includes('Release') || name.includes('Waiver') || name.includes('Guidelines')" class="link" target="_blank" :href="value">View {{name}}</a>
                    </div>
                  </template>
                  <button @click.stop.prevent="createEntryGroup" class="mt-2 btn btn-blue">
                    {{this.event.status === 'EVENT' ? 'Start Registration' : 'Start My Entry'}}
                  </button>
                </template>
                <template v-else-if="entryLoading">
                  <vue-simple-spinner size="large" :speed="1.1" :line-size="7" message="Creating Entry From" line-fg-color="orange"/>
                </template>
              </div>
            </div>
          </div>
        </div>
        <tabs ref="tabs" type="steps" v-else class="mt-4" @selectedTab="(tab) => {selectedTab = tab; entryProgress = tabList.findIndex(t => tab === t);}">
          <div class="flex justify-center my-4 border-b pb-3 md:border-0">
            <div class="inline-flex">
              <button @click="() => {entryProgress--; $refs.tabs.setTab(entryProgress)}" :disabled="entryProgress===0" :class="{'cursor-not-allowed': entryProgress===0, 'bg-gray-300': entryProgress===0, 'hover:bg-gray-300': entryProgress===0}" class="relative inline-flex items-center rounded-l-md border border-gray-500 bg-white px-2 py-1 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
                Back
              </button>
              <button @click="() => {entryProgress++; $refs.tabs.setTab(entryProgress)}" :disabled="entryProgress===3" :class="{'cursor-not-allowed': entryProgress===3, 'bg-gray-300': entryProgress===3, 'hover:bg-gray-300': entryProgress===3}" class="relative -ml-px inline-flex items-center rounded-r-md border border-gray-500 bg-white px-2 py-1 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
                Next
              </button>
            </div>
          </div>
          <tab :selected='selectedTab == "Account Info"' name="Account Info">
            <div class="w-full  overflow-hidden md:py-5 md:px-4 md:border md:border-gray-300 md:bg-white md:rounded mt-8">
              <SeriesMembershipList />

              <p class="text-2xl text-center">Account Contact Info</p>
              <div class="flex justify-center items-center">
                <div class='flex-1'>
                  <template v-if="event.entry_settings.has_member_pricing">
                    <label class="md:w-full block text-gray-700 font-bold" >
                      <p class="text-xl font-light">Are you a {{event.entry_settings.member_pricing_label}}?</p>
                      <input v-model="entryGroup.member_pricing" class="mr-2 leading-tight" type="checkbox" @change="updateEntryGroupMembership">
                      <span class="text-sm">
                        I am a {{event.entry_settings.member_pricing_label}}
                      </span>
                    </label>
                    <p class="text-sm text-gray-700 mt-2 font-semibold">**This box must be checked in order to receive the member discount pricing</p>
                  </template>
                  <ul class="font-light mt-4" v-if="currentUser.address">
                    <li><span class="font-bold">Farm:</span> {{currentUser.farm_name}}</li>
                    <li><span class="font-bold">Owner:</span> {{currentUser.first_name}} {{currentUser.last_name}}</li>
                    <li><span class="font-bold">Address:</span> {{currentUser.address.address_line1}}, {{currentUser.address.city}}, {{currentUser.address.state}} {{currentUser.address.zip}}</li>
                    <li><span class="font-bold">Phone:</span> {{currentUser.phone_number}}</li>
                    <li><span class="font-bold">Email:</span> {{currentUser.email}}</li>
                  </ul>
                  <p class="mt-4">
                    See something that isn't correct?
                    <br>
                    <router-link class="link" to="/myProfile">Click Here to edit</router-link>
                  </p>
                </div>
              </div>
            </div>
          </tab>
          <tab :name="event.status === 'EVENT' ? 'Registration' : 'Entries'" :selected="selectedTab == 'Entries'">
            <div class="md:py-5 md:px-4 md:border md:border-gray-300 md:bg-white md:rounded">
              <entryList :event="event" :entryGroup="entryGroup" listType="tabs"/>
            </div>
          </tab>
          <tab name="Entry Questions" :selected='selectedTab == "Entry Questions"'>
            <div v-if="event.entry_questions.length" class="w-full mt-3 mx-1 md:py-5 md:px-4 md:border md:border-gray-300 md:bg-white md:rounded">
              <entry-questions  :event="event" :entryGroup="entryGroup"/>
            </div>
            <div v-else>
              <h3 class="my-16 text-2xl font-semibold text-center">You're all set for this section. <br>There are no additional entry questions for this show.</h3>
            </div>
          </tab>
          <tab name="Confirm Entries" :selected='selectedTab == "Confirm Entries"'>
            <div v-if="missingRequiredQuestions" class="text-center w-full mx-auto p-4 bg-red-200 border-red-600 border rounded-lg my-3">
              <p class="text-xl font-medium pb-2">MISSING REQUIRED ENTRY QUESTIONS</p>
              <p>Please go review the QUESTIONS section before checking out.</p>
            </div>
            <template v-if="invoice.line_items">
              <div v-if="invoice.line_items.length">
                <h3 class="text-2xl font-semibold">Please review the following information:</h3>
                <p class="mb-2 font-medium text-gray-900">(**Link to the check out page is at the bottom)</p>
                <template v-if="event.entry_settings.has_member_pricing">
                  <label class="md:w-full block text-gray-700 font-bold">
                    <p class="text-xl font-light">Are you a {{event.entry_settings.member_pricing_label}}?</p>

                    <input v-model="entryGroup.member_pricing" class="mr-2 leading-tight" type="checkbox" @change="updateEntryGroupMembership">
                    <span class="text-sm">
                      I am a {{event.entry_settings.member_pricing_label}}
                    </span>
                  </label>
                  <p class="text-sm text-gray-700 my-2 font-semibold">**This box must be checked in order to receive the member discount pricing</p>
                </template>
                <div class="mb-3 md:py-5 md:px-4 md:border md:border-gray-300 md:bg-white md:rounded py-4">
                  <display-invoice :invoice="invoice" :showFees="true"/>
                </div>
                <div class="flex justify-center">
                <!-- <button @click="goToCheckout" class="btn btn-blue w-64 text-center">Go To Checkout</button>-->

                  <router-link v-if="!missingRequiredQuestions" v-bind:to="{ name: 'checkout', params: { show: event.event_identifier }}" class="btn btn-blue w-64 text-center">Go To Checkout</router-link>
                  <div v-else class="text-center w-full mx-auto p-4 bg-red-200 border-red-600 border rounded-lg my-3">
                    <p class="text-xl font-medium pb-2">MISSING REQUIRED ENTRY QUESTIONS</p>
                    <p>Please go review the QUESTIONS section before checking out.</p>
                  </div>
                </div>
              </div>
              <div v-else class="h-64">
                <h3 class="mt-16 text-2xl font-semibold text-center">Please add an entry if you would like to enter this {{this.event.status === 'EVENT' ? 'event' : 'show'}}.</h3>
              </div>
            </template>
          </tab>
          <div class="text-center mt-4" v-if="entryGroup.entry_group_id">
            <div class="text-center inline-flex">
              <button @click="() => {entryProgress--; $refs.tabs.setTab(entryProgress)}" :disabled="entryProgress===0" :class="{'cursor-not-allowed': entryProgress===0, 'bg-gray-300': entryProgress===0, 'hover:bg-gray-300': entryProgress===0}" class="relative inline-flex items-center rounded-l-md border border-gray-500 bg-white px-2 py-1 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
                Back
              </button>
              <button @click="() => {entryProgress++; $refs.tabs.setTab(entryProgress)}" :disabled="entryProgress===3" :class="{'cursor-not-allowed': entryProgress===3, 'bg-gray-300': entryProgress===3, 'hover:bg-gray-300': entryProgress===3}" class="relative -ml-px inline-flex items-center rounded-r-md border border-gray-500 bg-white px-2 py-1 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
                Next
              </button>
            </div>
          </div>
        </tabs>

      </div>
      <div v-else class="mt-8 text-center">
        <h2>Sorry about this, registration for this event is currently full.<br>We hope you will check back next year.</h2>
      </div>
    </template>
    <template v-else>
      <div class="p-2">
        <p class="text-3xl font-light">Interested in entering this show?</p>

        <p class="mt-2 text-xl text-gray-700">Please sign in or create an account to continue.</p>
        <div class="mt-4">
          <router-link to="/signin" class="btn btn-blue mr-4">
            Sign In
          </router-link>
          <router-link to="/signup" class="btn btn-green-outline">
            Create an Account
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import DisplayInvoice from '@/components/DisplayInvoice.vue'
import EntryQuestions from '@/components/EntryQuestions.vue'
import EntryList from '@/components/EntryList.vue'
import SeriesMembershipList from '@/components/SeriesMembershipListOnShow.vue'

import {parse} from 'date-fns'

// import Expandable from '@/components/Expandable'

export default {
  components: {
    DisplayInvoice,
    EntryQuestions,
    EntryList,
    SeriesMembershipList
  },
  name: 'enter-show',
  props: {
    refreshData: Function
  },
  data () {
    return {
      selectedTab: 'Account Info',
      entryLoading: false,
      entryProgress: 0,
      tabList: ['Account Info', 'Entries', 'Entry Questions', 'Confirm Entries'],
      // Event Data
      agreeToRules: false
      // memberPricing: null
    }
  },
  methods: {
    createEntryGroup () {
      if (!this.agreeToRules) {
        this.notie.alert({
          type: 2,
          text: `You must agree to read and agree to all show rules before starting your entry.`
        })
        return
      }
      this.entryLoading = true
      this.$store.dispatch('createEntryGroup', {agreeToRules: this.agreeToRules, member_pricing: this.memberPricing})
        .then(response => {
          // Need to replace new way to refresh
          this.entryLoading = false
          this.refreshData()
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error starting entry. Please refresh your browser and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    updateEntryGroupMembership () {
      this.$store.dispatch('updateEntryGroup', {
        entry_group_id: this.entryGroup.entry_group_id,
        member_pricing: this.entryGroup.member_pricing
      })
    },
    /* goToCheckout () {
      if (!this.missingRequiredQuestions) {
        this.$router.push({
          name: 'checkout',
          params: {
            show: this.event.event_identifier
          }
        })
      } else {
        this.notie.alert({
          type: 3,
          text: `<p class="text-3xl font-medium pb-2">MISSING REQUIRED ENTRY QUESTIONS</p><p>Please go review the QUESTIONS section before checking out.</p>`
        })
      }
    }, */
    questionIsPastDue (q) {
      let now = new Date()
      let dateString = `${now.getFullYear()}-${('0' + (now.getMonth() + 1)).slice(-2)}-${('0' + now.getDate()).slice(-2)}`

      if (q.details.due_date) {
        if (parse(q.details.due_date) >= new Date(dateString)) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  computed: {
    event () {
      return this.$store.state.event.currentEvent
    },
    currentUser () {
      return this.$store.state.user
    },
    entryGroup () {
      return this.$store.state.entryGroup.currentEntryGroup
    },
    invoice () {
      return this.$store.state.entryGroup.invoice
    },
    allowMoreRegistrations () {
      if (this.event.status === 'EVENT') {
        return this.event.event_settings.max_entries > this.$store.state.event.entry_count
      } else {
        return true
      }
    },
    missingRequiredQuestions () {
      let missing = false
      if (this.entryGroup.entry_questions) {
        this.event.entry_questions.forEach(q => {
          if (q.details.required && !this.questionIsPastDue(q)) {
            if (!q.details.exhibitor_question) {
              // Pla with fxing thins
              if (q.details.multi_answer && q.details.answer_type !== 'dropdown') {
                q.details.answer_options.forEach(option => {
                  if (!option.disabled) {
                    let a = this.entryGroup.entry_questions[`${q.entry_question_id}:${option.id}`]
                    if (a === null || a === '' || typeof a === 'undefined' || a === false) {
                      missing = true
                    }
                  }
                })
              } else {
                let a = this.entryGroup.entry_questions[q.entry_question_id]
                if (a === null || a === '' || typeof a === 'undefined' || a === false) {
                  missing = true
                }
              }
            } else {
              this.entryGroup.exhibitors.forEach(e => {
                if (q.details.multi_answer && q.details.answer_type !== 'dropdown') {
                  q.details.answer_options.forEach(option => {
                    let a = this.entryGroup.entry_questions[`${q.entry_question_id}:${option.id}:${e.exhibitor_id}`]
                    if (a === null || a === '' || typeof a === 'undefined' || a === false) {
                      missing = true
                    }
                  })
                } else {
                  let a = this.entryGroup.entry_questions[`${q.entry_question_id}:${e.exhibitor_id}`]
                  if (a === null || a === '' || typeof a === 'undefined' || a === false) {
                    missing = true
                  }
                }
              })
            }
          }
        })
      }
      return missing
    }
  }
}
</script>

<style>
.fill {
  fill: white;
}
</style>
